import React, { useEffect } from "react";
import { startGlobus } from "./StartGlobus";

interface Props extends React.HTMLProps<HTMLDivElement> {}

const Globus: React.FC<Props> = (props) => {
    useEffect(() => {
        startGlobus();
    }, []);

    return (
        <div className={["demo", props.className].join(" ")}>
            <div className="animation-wrapper">
                <canvas id="globe-3d"></canvas>
                <canvas id="globe-2d-overlay"></canvas>
            </div>
        </div>
    );
};

export default Globus;
